/* eslint-disable react/jsx-filename-extension */
import React from "react";

function ShowRightDropDownMenu({ showMenu, setShowMenu, href, name, id, closeLeftRightMenu }) {
  return (
    <span aria-hidden id={id || ""} className={`menu-link ${showMenu ? "show" : ""}`}>
      <a onClick={() => closeLeftRightMenu()} href={href} className="menu-title">
        {name}
      </a>
      <span aria-hidden="true" onClick={() => setShowMenu(!showMenu)} className="menu-arrow" />
    </span>
  );
}
export default ShowRightDropDownMenu;
